import React from 'react';
import { string } from 'prop-types';
import './dropdown.scss';

export const DropdownItem = (props) => {
  const {
    attributeValue,
    swatchGuid
  } = props;

  return (
    <>
      {swatchGuid && (
        <span className="swatch__image">
          <img
            alt={attributeValue}
            src={swatchGuid}
            title={attributeValue}
          />
        </span>
      )}
      {attributeValue}
    </>
  );
};

DropdownItem.displayName = 'DropdownItem';

DropdownItem.propTypes = {
  attributeValue: string,
  swatchGuid: string
};

DropdownItem.defaultProps = {
  attributeValue: null,
  swatchGuid: null
};
